<ng-container *ngIf="!isLoading">
  <div class="stylesheet-page forceDefaultColors">
    <h1 class="page-title">Style Guide</h1>
    <div class="stylesheet-grid">
      <app-btn></app-btn>
      <app-badge></app-badge>
      <app-alert-message></app-alert-message>
      <app-dropdown-generator></app-dropdown-generator>
    </div>
  </div>
</ng-container>
